module.exports = __webpack_public_path__ + "static/media/sketch3.578f1289.jpg";